<template>
  <div>
    <ExamHeader :activity-quest-type="activityQuestType" :is-delegation-code="isDelegationCode">
      <template
        v-if="isDelegationCode"
        #progress
      >
        <UnlockInfo
          :is-delegation-code="isDelegationCode"
          :exam-progress="examProgress"
          :maximum-pprogress="maximumPprogress"
          :exam-total-count="examList.length || casePracticeExamCount"
          :quest-amount="questAmount"
          :have-get="haveGet"
          :accept-delegation="acceptDelegation"
          :is-accept-delegation="isAcceptDelegation"
          :code-id="codeId"
          :is-expired="isExpired"
          @onAcceptDelegation="$emit('onAcceptDelegation', $event)"
        />
      </template>
      <template #exams>
        <AnswerContainer
          v-if="isShowExam"
          ref="answer-container"
          class="question-list"
          :list="examList"
          :is-show-bg="activityQuestType === 2 ? false : true"
          :theme-name="activityQuestType === 2 ? 'case-practice' : 'default'"
          :is-show-correct="(isAnswered || isResetBtn || isSubmit) && !isTwoSelect"
          :disabled="
            ((isAnswered || isResetBtn || isSubmit || isExpired) && !isTwoSelect) || disabled
          "
          :before-change="beforeChange"
        />
      </template>
    </ExamHeader>
    <div v-if="activityQuestType === 1" class="quest-body qxs-flex qxs-flex-vertical-center">
      <div class="visit-content-box">
        <template v-if="!isShowExam">
          <div class="suo-box">
            <img :src="require('@/assets/public/suo.png')" alt="">
          </div>
        </template>
        <qxs-row v-if="isDelegationCode && isShowExam" type="flex">
          <qxs-button
            v-if="!isResetBtn"
            type="primary"
            class="qxs-flex-fill"
            size="large"
            :disabled="isAnswered || isSubmit || isLoading || isExpired || disabled"
            @click="submit"
          >
            {{
              isAnswered || isSubmit
                ? "已答题"
                : isLoading
                  ? "正在提交"
                  : isExpired
                    ? "已过期"
                    : "提交"
            }}
          </qxs-button>
          <qxs-button
            v-else
            type="primary"
            class="qxs-flex-fill"
            size="large"
            @click="onReverGift"
          >
            领取奖励
          </qxs-button>
        </qxs-row>
        <qxs-row v-if="isResetBtn" type="flex" style="margin-top: 15px;">
          <qxs-button
            type="primary"
            plain
            class="qxs-flex-fill"
            size="large"
            @click="onVaild"
          >
            <div>
              <span class="font-weight">3积分重新答题</span>
              <span style="font-size: 12px;">(剩余时间{{ showTime }})</span>
            </div>
          </qxs-button>
        </qxs-row>
      </div>
      <qxs-dialog :show="showProgressModal">
        <div>
          <div>
            您观看视频未达到一定条件，尚未解锁{{ sceneText }}答题。请先观看{{
              sceneText
            }}视频，并关注如图所示的进度条，成功解锁后可答题。
          </div>
          <div class="progress-show-box">
            <span>{{ !(examProgress >= maximumPprogress) ? "解锁进度" : "已解锁" }}</span>
            <div v-if="examProgress < maximumPprogress" class="progress">
              <div class="progress-line" :style="{ width: examProgress + '%' }" />
            </div>
            <div v-if="examProgress < maximumPprogress" style="margin-left: 10px;">
              {{ examProgress }}%
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer" @click="onCloseModal">我知道了</div>
      </qxs-dialog>
    </div>
    <template v-else-if="activityQuestType === 2">
      <div v-if="isDelegationCode && !isExpired && examProgress < maximumPprogress" class="suo-box">
        <img :src="require('@/assets/public/suo.png')" alt="">
      </div>
      <fixed-action-bar
        v-if="examProgress >= maximumPprogress && acceptDelegation"
        class="customize-fixed-action-bar fixed-bar"
      >
        <van-button
          v-if="!isExpired && ![1, 4].includes(delegationStatus)"
          type="primary"
          size="large"
          @click="handleAcceptDelegation"
        >
          前往挑战
        </van-button>
        <van-button
          v-else
          type="primary"
          size="large"
          @click="handleViewDetail"
        >
          查看详情
        </van-button>
      </fixed-action-bar>
    </template>
  </div>
</template>

<script>
import { submitLiveExam, onReceiveLiveExamGift } from '@/service/LiveService'
import { submitConferenceExam, onReceiveConferenceExamGift } from '@/service/ConferenceService'
import { mapGetters, mapActions } from 'vuex'
import AnswerContainer from '@/components/Answer/AnswerContainer.vue'
import ExamHeader from './exam-header.vue'
import UnlockInfo from './unlock-info.vue'
import { once } from '@/utils/util'
import { RecordTime, recordTimeMixin } from '@/utils/record-time.js'
import { setLocalStorage, getLocalStorage, removeLocalStorage, msFormatTime } from '@/utils/util'

const PROGRESS_THRESHOLDS = {
  MEETING: 95,
  LIVE: 100
}

export default {
  name: 'SceneExam',
  components: {
    AnswerContainer,
    ExamHeader,
    UnlockInfo
  },
  mixins: [recordTimeMixin],
  props: {
    sceneType: {
      type: String,
      default: 'live' // meeting | live
    },
    orgModel: {
      type: Object,
      default() {
        return {}
      }
    },
    codeId: {
      type: String,
      default: ''
    },
    isAnswered: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isExpired: {
      type: Boolean,
      default: false
    },
    acceptDelegation: {
      type: Boolean,
      default: false
    },
    settled: {
      type: Boolean,
      default: false
    },
    haveGet: {
      type: Number,
      default: 0
    },
    examProgress: {
      type: Number,
      default: 0
    },
    questAmount: {
      type: Number,
      default: 0
    },
    isDelegationCode: {
      type: Boolean,
      default: false
    },
    activityQuestType: {
      type: Number,
      default: 1
    },
    examList: {
      type: Array,
      default: () => []
    },
    delegationStatus: {
      type: Number,
      default: 2
    },
    activityQuestId: {
      type: String,
      default: ''
    },
    casePracticeExamCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isAcceptDelegation: false,
      exams: [],
      answerObj: {},
      saveExams: [],
      isLoading: false,
      isSubmit: false,
      timer: null,
      computedTime:
        (new Date(new Date().setHours(23, 59, 59)).getTime() - new Date().getTime()) / 1000,
      countDownTime: 86399,
      isResetAnswer: false,
      isResetBtn: false,
      giftData: {},
      showProgressModal: false,
      chooseArr: [],
      isTwoSelect: false,
      answerSign: null,
      answerTime: 0,
      startAnswerTime: null
    }
  },
  computed: {
    ...mapGetters(['doctorInfo']),
    maximumPprogress() {
      return PROGRESS_THRESHOLDS[this.sceneType.toUpperCase()]
    },
    isShowExam() {
      return this.isDelegationCode
        ? this.acceptDelegation || (!this.acceptDelegation && this.isAcceptDelegation)
        : true
    },
    sceneText() {
      return this.sceneType === 'meeting' ? '趣课堂' : '播客'
    },
    onSubmitConfirm() {
      return this.sceneType === 'meeting' ? submitConferenceExam : submitLiveExam
    },
    onReceiveConfirm() {
      return this.sceneType === 'meeting' ? onReceiveConferenceExamGift : onReceiveLiveExamGift
    },
    showTime() {
      let hour = parseInt((this.computedTime / 60 / 60) % 24)
      hour = hour > 9 ? hour : `0${hour}`
      let minute = parseInt((this.computedTime / 60) % 60)
      minute = minute > 9 ? minute : `0${minute}`
      let seconds = parseInt(this.computedTime % 60)
      const h = hour === '00' ? '' : `${hour}:`
      const m = minute === '00' ? '' : `${minute}:`
      if (h || m) {
        seconds = seconds > 9 ? seconds : `0${seconds}`
      } else {
        seconds = `${seconds} S`
      }
      return `${h}${m}${seconds}`
    },
    showProgress() {
      return this.examProgress < this.maximumPprogress && !this.isAnswered
    }
  },
  mounted() {
    this.initExamList()
    this.onStartAnswerTime()
    this.initRecordTime()
  },
  destroyed() {
    clearTimeout(this.timer)
    this.onSaveAnswerTime()
  },
  methods: {
    ...mapActions(['getDoctorInfo']),
    // 前往挑战
    handleAcceptDelegation() {
      this.$router.replace({
        name: 'CasePractice',
        params: {
          activityQuestId: this.activityQuestId
        },
        query: {
          codeId: this.codeId,
          sceneType: this.sceneType
        }
      })
    },

    // 查看详情
    handleViewDetail() {
      this.$router.push({
        name: 'CasePracticeDetail',
        params: {
          activityQuestId: this.activityQuestId
        },
        query: {
          codeId: this.codeId
        }
      })
    },
    onStartAnswerTime() {
      clearTimeout(this.startAnswerTime)
      this.answerSign = `${this.sceneType}-${this.codeId}`
      this.answerTime = Number(getLocalStorage(this.answerSign) || 0)
      if (
        (this.acceptDelegation || (!this.acceptDelegation && this.isAcceptDelegation)) &&
        !this.isExpired &&
        !(this.isAnswered || this.isSubmit)
      ) {
        this.startAnswerTime = setInterval(() => {
          this.answerTime += 1000
        }, 1000)
      }
    },
    onSaveAnswerTime() {
      clearTimeout(this.startAnswerTime)
      if (
        (this.acceptDelegation || (!this.acceptDelegation && this.isAcceptDelegation)) &&
        !this.isExpired &&
        !(this.isAnswered || this.isSubmit)
      ) {
        setLocalStorage(this.answerSign, this.answerTime)
      } else {
        removeLocalStorage(this.answerSign)
      }
    },
    onAcceptDelegation(flag) {
      this.isAcceptDelegation = flag
      this.onStartAnswerTime()
      this.$emit('onAcceptDelegation', flag)
    },
    initRecordTime() {
      // 检查 codeId 是否有效，避免创建无效的 RecordTime 实例
      if (!this.codeId) {
        console.warn('SceneExam: codeId is empty, skipping RecordTime initialization')
        return
      }

      this.record__key[`${this.sceneType}OnceAnswerTime`] = new RecordTime({
        id: this.codeId,
        params: {
          businessRecordType: 2
        }
      })

      this.record__key[`${this.sceneType}SecondAnswerTime`] = new RecordTime({
        id: this.codeId,
        params: {
          businessRecordType: 3
        }
      })

      this.secondAnswer = once(() => {
        this.record__key[`${this.sceneType}SecondAnswerTime`].start()
      })

      this.onceAnswer = once(() => {
        this.record__key[`${this.sceneType}OnceAnswerTime`].start()
      })
    },
    beforeChange() {
      if (this.showProgress) {
        this.onShowModal()
        return false
      }
      if (this.isResetAnswer) {
        this.secondAnswer()
      } else {
        this.onceAnswer()
      }
      return true
    },
    emitInitExamGift({
      examGiftCount,
      totalGiftCount,
      rightAnswers,
      totalQuestions,
      isSecondSubmit = this.isResetAnswer,
      answerTime = this.answerTime
    } = {}) {
      this.$emit('initExamGift', {
        examGiftCount,
        totalGiftCount,
        rightAnswers,
        totalQuestions,
        isSecondSubmit,
        answerTime
      })
      clearTimeout(this.startAnswerTime)
      this.$analysysAgentTrack('doctor_detail_submit_survey', {
        survey_all_gifts: this.questAmount,
        survey_have_gifts: examGiftCount,
        survey_number: this.examList?.length,
        whether_second_survey: isSecondSubmit,
        survey_time: msFormatTime(answerTime),
        ...this.orgModel
      })
    },
    /**
     * 提交答题
     * 处理答题提交、计时暂停/恢复、奖励发放等逻辑
     */
    submit() {
      // 防重复提交检查
      if (this.isLoading) return this.$msg('请勿重复提交')
      if (this.isAnswered) return // 已答题
      if (this.isExpired) return // 已过期
      if (this.isSubmit) return // 已提交

      // 获取答题容器的答案
      this.$refs['answer-container']
        .onSubmit()
        .then(res => {
          this.isLoading = true
          // 转换答案格式
          const arr = res.map(item => item?.submitAnswerObj).filter(item => item)

          // 暂停答题计时
          if (this.isResetAnswer) {
            // 二次答题计时暂停
            this.record__key[`${this.sceneType}SecondAnswerTime`].pause()
          } else {
            // 首次答题计时暂停
            this.record__key[`${this.sceneType}OnceAnswerTime`].pause()
          }

          // 调用对应场景(趣课堂/趣直播)的提交接口
          this.onSubmitConfirm(arr, this.codeId, this.isResetAnswer).then(
            res => {
              // 关闭答题计时
              if (this.isResetAnswer) {
                this.record__key[`${this.sceneType}SecondAnswerTime`].close(false)
              } else {
                this.record__key[`${this.sceneType}OnceAnswerTime`].close(false)
              }

              // 解构接口返回数据
              const {
                data: {
                  exams, // 题目列表
                  rightAnswers, // 正确答案数
                  totalQuestions, // 总题目数
                  totalGiftCount, // 总奖励数
                  examGiftCount, // 获得奖励数
                  isAbleAnswerTwice // 是否可以二次答题
                }
              } = res

              // 重置加载状态
              this.isLoading = false
              // 更新题目列表
              this.$emit('onReplaceExam', exams)
              // 保存答题结果数据
              this.giftData = { rightAnswers, totalQuestions, totalGiftCount, examGiftCount }

              // 判断是否需要显示二次答题按钮
              if (!isAbleAnswerTwice || rightAnswers === totalQuestions || this.isResetAnswer) {
                // 不允许二次答题 或 全部答对 或 已是二次答题
                this.isSubmit = true
                this.emitInitExamGift(res.data)
              } else {
                // 允许二次答题，计算剩余时间并显示二次答题按钮
                this.computedTime =
                  (new Date(new Date().setHours(23, 59, 59)).getTime() - new Date().getTime()) /
                  1000
                this.isResetBtn = true
                this.doIntervalCount()
                this.$emit('checkResetToast')
              }
            },
            rea => {
              // 提交失败处理
              this.$msg(rea.message)
              this.isLoading = false
              // 恢复答题计时
              if (this.isResetAnswer) {
                this.record__key[`${this.sceneType}SecondAnswerTime`].resume()
              } else {
                this.record__key[`${this.sceneType}OnceAnswerTime`].resume()
              }
            }
          )
        })
        .catch(error => {
          // 答案验证失败处理
          if (error.row) {
            this.$msg(`第${error.row?.titleIndex}题，${error.message}`)
          }
        })
    },
    onVaild() {
      this.getDoctorInfo().then(
        () => {
          if (this.doctorInfo.kitCount < 3) return this.$msg('您的积分不足')
          this.onResetAnswer()
        },
        rea => {
          this.$msg(rea.message)
        }
      )
    },
    /**
     * 重置答题状态，开始二次答题
     * 清除计时器、重置答题状态、重置答题容器
     */
    onResetAnswer() {
      // 检查答题时间是否已过期
      if (this.computedTime == 0) return this.$msg('答题机会已过期')

      // 清除倒计时定时器
      clearTimeout(this.timer)

      // 设置为二次答题状态
      this.isResetAnswer = true
      // 启用二次选择模式
      this.isTwoSelect = true
      // 隐藏重新答题按钮
      this.isResetBtn = false

      // 重置答题容器的选项状态
      this.$refs['answer-container'].reset()

      // 通知父组件开始二次答题
      this.$emit('onResetAnswer')
    },
    onReverGift() {
      this.onReceiveConfirm(this.codeId).then(
        res => {
          const {
            data: { exams }
          } = res
          this.isLoading = false
          this.isResetBtn = false
          this.isSubmit = true
          clearTimeout(this.timer)
          this.emitInitExamGift(res.data)
          this.$emit('onReplaceExam', exams)
        },
        rea => {
          this.$msg(rea.message)
        }
      )
    },
    setData(options) {
      const examId = options.examId
      const answers = options.selectStr
      const obj = options.item
      const index = options.index

      let answer = ''
      let answerCheck = ''
      obj.answers &&
        obj.answers.map(item => {
          if (item.isCorrect) {
            answer += `${item.answer};`
          }
          if (item.isChoice) {
            answerCheck += `${item.answer};`
          }
        })
      if (answerCheck) {
        this.$analysysAgentTrack('doctor_ksh_answer_click', {
          question_title: obj.title || '',
          question_answer: answer,
          question_doctor_choose: answerCheck,
          type: this.sceneType,
          ...this.orgModel
        })
      }
      this.$set(this.chooseArr, index, {
        title: obj.title || '',
        answer: answer,
        choose: answerCheck
      })

      if (examId && answers) {
        this.answerObj[examId] = answers
      } else if (examId && !answers) {
        delete this.answerObj[examId]
      }
    },
    doIntervalCount() {
      this.timer = setTimeout(() => {
        this.computedTime--
        this.doIntervalCount()
        if (this.computedTime == 0) {
          clearTimeout(this.timer)
        }
      }, 1000)
    },
    onShowModal() {
      this.showProgressModal = true
      this.$emit('handleExamProgress')
    },
    onCloseModal() {
      this.showProgressModal = false
    },
    initExamList() {
      if (this.isAnswered && !this.settled) {
        this.isResetBtn = true
        this.computedTime =
          (new Date(new Date().setHours(23, 59, 59)).getTime() - new Date().getTime()) / 1000
        this.doIntervalCount()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.quest-body {
  margin: 10px;
  flex-direction: column;
  font-size: $font-size-small;
  color: $text-color-main;
}
.visit-content-box {
  width: 100%;
}
.dialog-footer {
  line-height: 45px;
  text-align: center;
  color: $text-color-primary;
  font-size: 16px;
  border-top: 1px solid #f0f0f0;
  border-radius: 0 5px;
}
.progress-show-box {
  margin-top: 15px;
  display: flex;
  justify-content: row nowrap;
  align-items: center;
  color: $text-color-info;
  font-size: 12px;
}
.progress-line {
  background-color: $color-assist-light;
  border-radius: 4px;
  height: 8px;
  transition: all 200ms cubic-bezier(0.17, 0.86, 0.73, 0.14);
  position: absolute;
}
.suo-box {
  display: flex;
  justify-content: center;
  background: #f0f0f0;
  margin-top: -15px;
  padding: 100px 0;
  img {
    width: 32px;
  }
}
.fixed-bar {
  :deep(.placeholder) {
    background-color: #fff;
  }
}
.mgn-t5 {
  margin-top: 5px;
}
.mgn-b5 {
  margin-bottom: 5px;
}
</style>
